import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import BtnPhone from './BtnPhone';
import styles from '../../src/assets/styles/Footer.module.scss'; // Ujistěte se, že cesta k souboru CSS je správná
import OteviraciDoba from './OteviraciDoba';


const Footer = () => {
    return (
        <div className={`${styles.footer} bg-hermiona-dark`}>
            <Container>
                <Row>
                    <Col lg={4} className='text-center mb-4'>
                        <h5>Kontakt</h5>
                        <p>Mládežnická 422, Neratovice</p>
                        <p>Email: info@hernamaugli.cz</p>
                        <BtnPhone />
                    </Col>
                    <Col lg={4} className='text-center mb-4'>
                        <h5>Odkazy</h5>
                        <ul className="list-unstyled">
                            <li><a className={styles.link} href="/cenik">Ceník</a></li>
                            <li><a className={styles.link} href="/kavarna">Kavárna</a></li>
                        </ul>
                        <h5>Sociální sítě</h5>
                        <div className="social-icons">
                            <a className={styles.link} href="https://www.instagram.com/hernamaugli/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            <br />
                            <a className={styles.link} href="https://www.facebook.com/profile.php?id=100052775843578" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faFacebook} />
                            </a>
                        </div>
                    </Col>
                    <Col lg={4} className='text-center mb-4'>
                        <OteviraciDoba type="forFooter" />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;

